import type { ReactElement } from 'react';
import { usePublicAssetRequestsSuspenseQuery } from '../../../../../generated/graphql.tsx';
import { Grid } from '@mui/joy';
import GridCard, { type GridWidth } from '../../../../technical/GCard/GridCard.tsx';
import WithDialog from '../../../../technical/inputs/withDialogHoc/WithDialog.tsx';
import { CreatePublicAssetRequestDialog } from './CreatePublicAssetRequestDialog.tsx';
import PublicAssetRequestCard from './PublicAssetRequestCard.tsx';
import { ADD_NEW_CARD_STYLE } from 'components/technical/GCard/consts.ts';

const GCardWithDialog = WithDialog(GridCard);
const PublicAssetRequestManagementList = ({
  cardHeight,
  gridWidth,
  filterInput,
}: { cardHeight: string; gridWidth: GridWidth; filterInput: string }): ReactElement => {
  const { data } = usePublicAssetRequestsSuspenseQuery();

  const filteredList = filterInput
    ? data.assets.publicAssetRequests.filter((asset) => asset.symbol?.toLowerCase().includes(filterInput.toLowerCase()))
    : data.assets.publicAssetRequests;

  return (
    <Grid container spacing={3}>
      <GCardWithDialog
        cardSx={ADD_NEW_CARD_STYLE}
        renderDialog={({ onClose }): ReactElement => (
          <CreatePublicAssetRequestDialog onAdded={onClose} onClose={onClose} />
        )}
        height={cardHeight}
        gridWidth={gridWidth}
        addNewText="Add using Coingecko id"
      />
      {filteredList.map((req, i) => (
        <PublicAssetRequestCard key={i} request={req} gridWidth={gridWidth} height={cardHeight} />
      ))}
    </Grid>
  );
};

export default PublicAssetRequestManagementList;
